import { Box, CircularProgress, Typography } from "@mui/material"
import { ReactNode } from "react"

interface LoadingOverlayProps {
  loading: boolean
  text?: string
  spinnerColor?: string
  textColor?: string
  bgColor?: string
  children: ReactNode
}

export const LoadingOverlay = ({
  loading,
  text,
  spinnerColor = "#9ee5f8",
  textColor = "#676767",
  bgColor = "rgba(241, 241, 241, 0.95)",
  children,
}: LoadingOverlayProps) => (
  <Box position="relative">
    {children}
    {loading && (
      <Box
        position="absolute"
        top={0}
        right={0}
        bottom={0}
        left={0}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        bgcolor={bgColor}
        zIndex={(theme) => theme.zIndex.tooltip + 1}
        p={2}
        gap={1}
      >
        <CircularProgress sx={{ color: spinnerColor }} />
        {text && (
          <Typography variant="body1" sx={{ color: textColor, fontWeight: 500 }}>
            {text}
          </Typography>
        )}
      </Box>
    )}
  </Box>
)
